/**
 * Manually generated based on API response, might subject to change
 */

interface MessageOption {
  text: string
  feedback: 'positive' | 'neutral' | 'negative'
  actionType: string
}

export enum MessageType {
  PROMPTED = 'prompted',
  TEXT = 'text',
  SYSTEM = 'system',
  FILE = 'file',
  IMAGE = 'image',
  PRODUCT_CARD = 'product_card',
  ACTIVITY_LIST = 'activity_list',
}

export interface Message {
  id: number
  chatroomId: number
  senderId: number | null
  supplierId: number | null
  senderName: string
  messageType: MessageType
  content: string
  meta: {
    options?: MessageOption[]
    memberReadStatus: Record<string, string>
  }
  deletedAt: string | null
  createdAt: string
  updatedAt: string
  contentTsvector: string
  aiMessage: boolean
  senderSlug: string | null
  supplierSlug: string | null
  memberReadStatus: Record<string, string>
  tempId: string | null
  initiator: any | null
  invitee: any | null
  removee: any | null
  productId: string | null
  options: MessageOption[]
  aiActivity: any | null
  aiMessageOverride: boolean | null
  aiResponseTo: string | null
  aiConversationId: string | null
}

interface UserMember {
  name: string
  email: string
  'confirmed?': boolean
  attachedPhotoUrl: boolean
  questionnaires: any | null
  bio: string | null
  bioHtml: string | null
  instagramUsername: string | null
  tiktokUsername: string | null
  graduationYear: number | null
  study: string | null
  avatar: string
  hasPassport: boolean
  hasValidPassport: boolean
  hasInvalidPassport: boolean
  hasHeroTrips: boolean
  isAdmin: boolean
  id: string
}

interface AirtableItinerary {
  quoteReference: string
  recommendedItineraryUrl: string
  id: string
}

interface ItineraryRequest {
  country: string
  dates: string
  requestDates: string
  group: string
  activities: string | null
  stay: string | null
  accommodationType: string | null
  bedRequirements: string | null
  title: string
  targetCountryName: string
  featureImageUrl: string
  url: string
  recommendedItineraryUrl: string
  durationNights: number
  minPrice: number | null
  budgetText: string
  requestDatesText: string
  purposes: string | null
  vibes: string | null
  inspiration: string[]
  amendments: any | null
  matched: boolean
  id: string
  airtableItinerary: AirtableItinerary
}

export enum ChatroomStatus {
  ACTIVE = 'active',
  ARCHIVED = 'archived',
  INACTIVE = 'inactive',
}

export interface Chatroom {
  name: string
  productId: string | null
  itineraryRequestId: number
  createdAt: string
  lastMessage: Message
  aiActive: boolean
  tourheroes: any | null
  active: boolean
  status: ChatroomStatus
  id: string
  product: any | null
  operatorMembers: any[]
  userMembers: UserMember[]
  itineraryRequest: ItineraryRequest
}
